export const truncateWord = (word: string): string => {
  if (word.length <= 10) {
    return word; // No need to truncate if the word is already short
  }

  const firstPart = word.slice(0, 6);
  const lastPart = word.slice(-3);

  return `${firstPart}......${lastPart}`;
};
export const truncateWordd = (word: string): string => {
  if (word.length <= 10) {
    return word; // No need to truncate if the word is already short
  }

  const firstPart = word.slice(0, 15);
  const lastPart = word.slice(-9);

  return `${firstPart}......${lastPart}`;
};

/**
 * Counts of things — customers, products, sales, transaction counts.
 *
 * These are whole numbers and must not be rendered through formatAmount, which
 * always pads to 2 decimals and turned "5 customers" into "5.00".
 * Fractional input is kept rather than silently rounded away.
 */
export function formatCount(value: any) {
  if (value === null || value === undefined || value === "") return "0";

  const numValue = Number(value);
  if (Number.isNaN(numValue)) return "0";

  return numValue.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: Number.isInteger(numValue) ? 0 : 2,
  });
}

export function formatAmount(value: any) {
  if (value === null || value === undefined) return "0.00"; // Handle null/undefined values

  const numValue = Number(value); // Convert to a number

  // Return '0.00' for zero value
  if (numValue === 0) return "0.00";

  // For values >= 0.01, format with 2 decimal places
  if (numValue >= 0.01) {
    return numValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
    });
  }

  // For small values < 0.01, handle with higher precision (up to 8 decimals)
  const precision = Math.abs(numValue) < 0.0001 ? 8 : 6; // Use 6 or 8 decimals based on magnitude
  return numValue.toLocaleString("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
}

  export function formatDateTime(dateTime: string): string {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  const date = new Date(dateTime);
  const month = months[date.getMonth()];
  const day = date.getDate();
  
  const hours = date.getHours();
  const minutes = date.getMinutes();
  
  // Format hours and minutes to 12-hour format
  const formattedHours = hours % 12 || 12; // Convert 0 -> 12 for AM/PM
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  return `${month} ${day} | ${formattedHours}:${formattedMinutes}${ampm}`;
}